import { FunctionComponent, useContext, useEffect } from 'react'
import { useFeathersClient } from '@strac/react-client-feathers'
import { App } from 'antd'
import { AuthContext } from '@strac/react-client-auth'

const Notifications: FunctionComponent<any> = () => {

  const client = useFeathersClient()

  const { notification } = App.useApp()

  const { authUser } = useContext(AuthContext) as any

  useEffect(() => {
    const listener = (data: any) => {
      if (data.user_id === authUser.id) {
        notification.info({
          message: data.message,
          description: data.description
        })
      }
    }
    client.service('notification').on('created', listener)
    return () => {
      client.service('notification').removeListener('created', listener)
    }
  }, [client, notification, authUser])

  return null
}

export default Notifications
